import React from 'react'
import {Link, RouteComponentProps} from '@reach/router'
import {useQuery} from '@apollo/client'

import {ensureList} from '../../utils/typing'
import {Page, Container, Loader} from '../layout'
import {getCategoriesQuery} from './queries'
import {GetCategories} from './_gql-types/GetCategories'
import { CategoryProps } from './_gql-types/CategoryProps'
import {BoxSeam} from 'react-bootstrap-icons'

interface OrderLineProps {
  category: CategoryProps
}

function CategoryCard({category}: OrderLineProps) {
  return (
    <Link
      to={`/verslun/vorur/?flokkar=${category.slug}`}
      className="text-reset card-hover-wrapper d-flex"
    >
      <div className="card border-0 rounded bg-white">
        <div className="card-body d-flex p-4">
          <BoxSeam size={25} className="text-primary mr-3" />
          <h5 className="card-title font-weight-bold mb-0 text-dark">{category.name}</h5>
        </div>

        <div className="card-footer bg-white border-0 text-right pt-0 px-4 pb-3">
          <span className="card-text text-muted">{category.products?.totalCount} vörur</span>
        </div>
      </div>
    </Link>
  )
}

export default function ProductCategories(_: RouteComponentProps) {
  const {loading, data} = useQuery<GetCategories>(getCategoriesQuery)
  const categories = data?.categories?.edges.filter(({node}) => node.products?.totalCount)

  return (
    <Page>
      <Container size="lg">
        <div className="row py-5">
          <div className="col-12">
            <h1 className="mb-5">Vöruflokkar</h1>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 gy-4">
              {loading ? (
                <Loader />
              ) : (ensureList(categories).map(({node}) => (
                <CategoryCard category={node} key={node.id} />
              )))}
            </div>
          </div>
        </div>
      </Container>
    </Page>
  )
}
